<mat-form-field [disabled]='props?.readonly' [required]='props.required' [appearance]="props.appearance">
    <mat-label>{{props.label}}{{props.isRequired ? ' *' : ''}}</mat-label>
    <input matInput 
      [placeholder]='props.hint' 
      [formControl]="formControl" 
      [formlyAttributes]="field" 
      [mask]="mask"
      [showMaskTyped]='true' 
      [title]="props.label"
      placeHolderCharacter=' ' >
<mat-hint *ngIf='!!props.description'>
  {{props.description}}
</mat-hint>
</mat-form-field>